import * as React from "react"

import { F1 } from "@smartdevis/utils/src/types"
import { keys, pickObject } from "@smartdevis/utils/src/map"
import {
    RenderOptions,
    ElementsRenderMap,
    RenderFn,
    FormLeafState,
    InputState,
    FormViewProps,
    InputPropsBase,
    InputSchema,
    FormSchema
} from ".."
import { plainHtmlElementRenderMap, plainHtmlRenderMap } from "./PlainHtmlRenderMap"

const getRenderMap = (p: RenderOptions) => p.inputsRenderMap || plainHtmlRenderMap

export const getElementsRenderMap = (p: RenderOptions): ElementsRenderMap => ({
    ...plainHtmlElementRenderMap,
    ...(p.elementsRenderMap || {})
})

const DefaultRenderFn: RenderFn<any> = p => <h3>Not supported {JSON.stringify(p.schema)}</h3>

export type InputViewProps = InputPropsBase<InputSchema<any>, FormLeafState<any>, F1<InputState<any>>> & { title?: string; };
export const FormItemView: React.FC<InputViewProps> = p => {
    const customRenderMap = { ...plainHtmlRenderMap, ...getRenderMap(p.renderOptions) }
    const { ItemWrapper, DefaultFormItem } = getElementsRenderMap(p.renderOptions)
    const FormItem = customRenderMap[p.schema.type] || DefaultFormItem || DefaultRenderFn

    return (
        <ItemWrapper>
            <FormItem {...(p as any)} title={p.title} />
        </ItemWrapper>
    )
}

export const FormView = <T extends any>(p: FormViewProps<T>): React.ReactElement => {
    const setDelta = (key: keyof T) => (value: any) => p.setState({ ...p.state, [key]: value })
    const renderOptions: RenderOptions = pickObject(p, ["elementsRenderMap", "inputsRenderMap"])

    const getProps = <TKey extends keyof FormSchema<T>>(key: TKey, schema: FormSchema<T>[TKey]): InputViewProps => ({
        schema,
        state: p.state[key],
        setDelta: setDelta(key),
        renderOptions
    })

    return (
        <>
            {keys(p.schema).map((key, i) => (
                <React.Fragment key={`${key}-${i}`}>
                    <FormItemView {...getProps(key, p.schema[key])} />
                </React.Fragment>
            ))}
        </>
    )
}
